/* @Copyright 2026. Institute for Future Intelligence, Inc. */

import { TorsionalBond } from './TorsionalBond.ts';
import { lookupTorsionParams } from './torsionParameters.ts';

/**
 * Apply OPLS-style torsion parameters to a list of TorsionalBond instances
 * in place. Bonds whose element quadruple is in the parameter table get
 * their strength / periodicity / dihedral set from the table; bonds not
 * in the table are left at the constructor defaults (strength = 1,
 * periodicity = 1).
 *
 * Call this once at chain-build time (polymerBuilder) and at any other
 * site that constructs TorsionalBond objects from scratch. Existing engine
 * code that constructs torsions via the torsionalBondsMap lookup should
 * ALSO call this if it relies on physical accuracy.
 */
export const applyTorsionParameters = (torsions: TorsionalBond[]): void => {
  for (const t of torsions) {
    const params = lookupTorsionParams([
      t.atom1.elementSymbol,
      t.atom2.elementSymbol,
      t.atom3.elementSymbol,
      t.atom4.elementSymbol,
    ]);
    if (!params) continue;
    t.strength = params.strength;
    t.periodicity = params.periodicity;
    t.dihedral = params.dihedralOffset;
  }
};
